import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import emailjs from "@emailjs/browser";
import "./Contact.css";
import { FaPhoneAlt, FaEnvelope, FaWhatsapp } from "react-icons/fa";

export default function Contact() {
  const [formType, setFormType] = useState("contact");
  const location = useLocation();
  const form = useRef();

  useEffect(() => {
    if (location.hash === "#consultation") {
      setFormType("consultation");
      const target = document.querySelector("#consultation");
      if (target) target.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  const sendEmail = (e) => {
    e.preventDefault();

    // نضيف reply_to مباشرة باش الرسائل توصل لإيميلك
    const formData = new FormData(form.current);
    formData.set("reply_to", "salmahoubbane22@gmail.com");

    emailjs
      .send(
        "service_08zi3be",    // Service ID
        "template_ialst4i",   // Template ID
        Object.fromEntries(formData), // تحويل FormData لكائن
        "m3_bt-mHthUB3Oh2J"   // Public Key
      )
      .then(() => {
        alert("✅ Votre message a été envoyé avec succès !");
        form.current.reset();
      })
      .catch((error) => {
        alert("❌ Erreur lors de l'envoi : " + error.text);
      });
  };

  return (
    <section id="consultation" className="contactSectionWhite">
      <div className="contactContainer">

        {/* ===== HEADER ===== */}
        <div className="contactHeader">
          <h1>
            {formType === "contact"
              ? "Contactez notre cabinet juridique"
              : "Demandez une consultation juridique"}
          </h1>

          <p>
            {formType === "contact"
              ? "Nous vous accompagnons dans toutes vos démarches et questions juridiques au Maroc."
              : "Obtenez une consultation personnalisée pour votre dossier juridique."}
          </p>
        </div>

        {/* ===== TOGGLE ===== */}
        <div className="contactToggle">
          <button
            className={formType === "contact" ? "active" : ""}
            onClick={() => setFormType("contact")}
          >
            Contact
          </button>

          <button
            className={formType === "consultation" ? "active" : ""}
            onClick={() => setFormType("consultation")}
          >
            Consultation
          </button>
        </div>

        <div className="contactWrapper">

          {/* ===== FORM ===== */}
          <form ref={form} onSubmit={sendEmail} className="contactForm">

            <div className="formGroup">
              <label>Nom complet</label>
              <input type="text" name="from_name" placeholder="Votre nom" required />
            </div>

            <div className="formGroup">
              <label>Email</label>
              <input type="email" name="reply_to" placeholder="exemple@email.com" required />
            </div>

            <div className="formGroup">
              <label>Téléphone</label>
              <input type="tel" name="phone" placeholder="+212 6 00 00 00 00" />
            </div>

            {formType === "consultation" && (
              <div className="formGroup">
                <label>Type de service juridique</label>
                <select name="service_type" required>
                  <option value="">Choisissez une option</option>
                  <option value="creation_entreprise">Création d’entreprise</option>
                  <option value="conseil_juridique">Conseil juridique</option>
                  <option value="contentieux">Contentieux</option>
                  <option value="contrats">Rédaction de contrats</option>
                  <option value="representation">Représentation légale</option>
                  <option value="fiscalite">Fiscalité</option>
                  <option value="autre">Autre</option>
                </select>
              </div>
            )}

            <div className="formGroup">
              <label>
                {formType === "contact"
                  ? "Votre message"
                  : "Détails de votre dossier"}
              </label>

              <textarea
                name="message"
                placeholder={
                  formType === "contact"
                    ? "Expliquez brièvement votre demande..."
                    : "Décrivez votre situation ou votre dossier en détail..."
                }
                rows="5"
                required
              ></textarea>
            </div>

            <button type="submit" className="sendButton">
              {formType === "contact"
                ? "Envoyer le message"
                : "Envoyer la demande de consultation"}
            </button>

          </form>

          {/* ===== INFO SECTION ===== */}
          <div className="contactInfo">

            <h2>NOS COORDONNÉES</h2>

            <div className="infoItem">
              <FaPhoneAlt className="icon" />
              <div>
                <p>Téléphone</p>
                <strong>(+212) 06 66 34 08 59</strong>
              </div>
            </div>

            <div className="infoItem">
              <FaEnvelope className="icon" />
              <div>
                <p>Email</p>
                <strong>info@cfjexpert.com</strong>
              </div>
            </div>

            <hr />

            <h2>WHATSAPP</h2>
            <p>Contactez-nous directement sur WhatsApp</p>

            <a
              href="https://wa.me/212666340859"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsappLink"
            >
              <FaWhatsapp className="icon" />
              CHAT WHATSAPP
            </a>

            <hr />

            <h2>LOCALISATION</h2>
            <p>Notre bureau à :</p>
            <br />
            <p>
              <strong>📍 Témara, Maroc</strong>
            </p>

            <div className="mapBox"></div>

          </div>

        </div>
      </div>
    </section>
  );
}